import { render, staticRenderFns } from "./data-table-item.vue?vue&type=template&id=6aef103e&scoped=true&"
import script from "./data-table-item.vue?vue&type=script&lang=js&"
export * from "./data-table-item.vue?vue&type=script&lang=js&"
import style0 from "./data-table-item.vue?vue&type=style&index=0&id=6aef103e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aef103e",
  null
  
)

export default component.exports